import { createApp } from 'vue'
import App from './AppComposition.vue'

createApp(App).mount('#app')
